import { LegalLayout } from './LegalLayout';

export function Refund() {
  return (
    <LegalLayout title="Refund Policy" lastUpdated="April 30, 2026">
      <p>
        Purchases of the eBook and paperback are completed on Amazon and are
        therefore covered by Amazon's refund policy, not ours.
      </p>

      <h2>Kindle eBook</h2>
      <p>
        Amazon allows Kindle book returns within 7 days of purchase if you have
        not read a substantial portion. Start a return from{' '}
        <a href="https://www.amazon.com/gp/digital/fiona/manage" target="_blank" rel="noopener noreferrer">
          Manage Your Content and Devices
        </a>{' '}
        in your Amazon account, or follow{' '}
        <a href="https://www.amazon.com/gp/help/customer/display.html?nodeId=GKM69DUUYKQWKWX7" target="_blank" rel="noopener noreferrer">
          Amazon's Kindle return instructions
        </a>.
      </p>

      <h2>Paperback</h2>
      <p>
        Amazon's standard 30-day return window applies to most paperback orders.
        See{' '}
        <a href="https://www.amazon.com/gp/help/customer/display.html?nodeId=GKM69DUUYKQWKWX7" target="_blank" rel="noopener noreferrer">
          Amazon's return policy
        </a>{' '}
        for details.
      </p>

      <h2>Need help?</h2>
      <p>
        Amazon Customer Service handles refunds and replacements directly. If
        you'd like us to follow up on something they cannot resolve — for example,
        a missing chapter or a corrupted file — email{' '}
        <a href="mailto:support@moneyskillsbook.com">support@moneyskillsbook.com</a>{' '}
        with your order ID and we'll do what we can.
      </p>
    </LegalLayout>
  );
}
